<template>
  <div>
    <transition name="fade">
      <!-- <div v-if="refreshSpin" class="loadingScreen">
        Yükleniyor...
      </div> -->
    </transition>
    <div class="content">
      <div class="row">
        <div class="col p-2 text-center ">
          <span class="lead">
            {{getJobTypeText(this.data.Filter.ListType)}}
          
            <button type="button" class="btn btn-sm float-end" @click="refreshClicked">
              <svg v-bind:class="{ spinning: refreshSpin }"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-arrow-repeat"
                viewBox="0 0 16 16"
              >
                <path
                  d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"
                />
                <path
                  fill-rule="evenodd"
                  d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                />
              </svg>
            </button>
          </span>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col">
          <div v-if="data.Result && data.Result.length > 0">
            <div
              :class="['card mb-2', currentStyle]"
              v-for="r in data.Result"
              :key="r.Id"
              @click="goToJob(r,r.Id)"
            >
              <div class="card-body">
                <h5 class="card-title">
                  <code
                    >{{ r.TrackingNo.Serial }}-{{ r.TrackingNo.Number }}</code
                  >
                </h5>
                <h6 class="card-subtitle mb-2 text-muted">{{ r.Title }}</h6>
                <div v-if="isWaitingList">
                  <p class="card-text">{{ r.Description }}</p>
                  <p class="cad-text">
                    <strong>Hedeflenen Bitiş:</strong>
                    {{ r.TargetDate | date }}
                  </p>
                </div>
              </div>
              <div class="card-footer text-muted">
                {{ getFromNow(r.CreateDate) }}
              </div>
            </div>
          </div>

          <div v-else class="note note-warning">
            <!-- <h3>Bilgi</h3> -->
            <p>Kayıt bulunamadı.</p>
          </div>
        </div>
      </div>
    </div>
    <nav
      class="navbar fixed-bottom navbar-light bg-light"
      aria-label="Page navigation"
    >
      <div class="container-fluid">
        <ul class="pagination pagination-lg w-100 h-100">
          <li class="page-item" :class="{ disabled: page <= 1 }">
            <button
              class="page-link"
              href="#"
              @click.prevent="
                page -= 1;
                getData();
              "
            >
              &laquo;
            </button>
          </li>
          <li class="page-item w-100 h-100">
            <select
              class="form-select page-link text-center"
              v-model="page"
              @change="getData()"
            >
              <option
                v-for="(v, i) in new Array(pageCount)"
                :key="i"
                :value="i + 1"
              >
                {{ i + 1 }}
              </option>
            </select>
          </li>
          <li class="page-item" :class="{ disabled: page >= pageCount }">
            <button
              type="button"
              class="page-link"
              href="#"
              @click.prevent="
                page += 1;
                getData();
              "
            >
              &raquo;
            </button>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      refreshSpin: false,
      errorMessage: null,
      loading: false,
      recordPerPage: 5,
      page: 1,
      data: {
        TotalRecordCount: 0,
        Result: [],
        predicate: "",
        Filter: {
          Predicate: "",
          Skip: 0,
          OrderBy: "TrackingNo.Number desc",
          ListType: window.location.hash?.replace("#", "") || "MyWaiting",
          Take: this.recordPerPage,
        },
      },
    };
  },
  computed: {
    hasRecord() {
      return this.data && this.data.Result && this.data.Result.length;
    },
    pageCount() {
      return (
        Math.ceil((this.data?.TotalRecordCount ?? 0) / this.recordPerPage) ?? 1
      );
    },
    currentSortField() {
      return this.data?.Filter?.OrderBy?.split(" ")[0];
    },
    currentSortDirection() {
      return this.data?.Filter?.OrderBy?.split(" ")[1] ?? "asc";
    },
    currentListType() {
      return this.data.Filter.ListType;
    },
    isWaitingList() {
      return this.currentListType == "MyWaiting" ? true : false;
    },
    currentStyle() {
      switch (this.currentListType) {
        case "MyApproved":
          return "border-success";
        case "MyDeclined":
          return "border-danger";
        case "MyCanceled":
          return "border-warning";
        default:
          return "";
      }
    },
  },
  methods: {
    getWindowHash(){
      return window.location.hash
    },
    goToJob(type,id){
      var hash = this.getWindowHash();
      if(hash.includes('Rem')){
        this.$router.push({ name: 'RemDetail', params: { id: id } })
      }else {
        this.$router.push({ name: 'JobDetail', params: { id: id } })
      }
      console.log(type,id)
    },
    getData() {
      this.errorMessage = null;
      this.loading = true;
      var f = this.data?.Filter || {};

      if (this.filter && typeof this.filter === "object")
        Object.assign(f, this.filter);

      f.Skip = (Math.max(this.page, 1) - 1) * this.recordPerPage;
      f.Take = this.recordPerPage;
      f.Predicate = this.predicate;
      f.ListType = window.location.hash?.replace("#", "") || "MyWaiting";

      console.log("filter:", f);

      axios
        .post("/job/get", f)
        .then((x) => {
          console.log("POST Result:", x.data);
          this.data = x.data;
          if (this.page > this.pageCount) this.page = this.pageCount;
          this.$forceUpdate();
          this.$emit("onload");
        })
        .catch((x) => {
          this.$emit("onerror", "İşlem gerçekleştirilemedi: " + x);
        })
        .then(() => {
          this.loading = false;
          setTimeout(() => {
            this.refreshSpin = false;
          }, 500);
          
        });
    },
    getFromNow(date) {
      return this.$date(date).fromNow();
    },
    refreshClicked(){
      this.refreshSpin = true;
      this.data.Result = [];
      this.getData()
    }
  },
  created() {
    this.getData();
  },
};
</script>
<style scoped>
.loadingScreen{
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  margin: 0;
  padding: 0;
  z-index: 99999;
  margin-left: -13px;
  backdrop-filter: blur(5px);
}
.spinning {
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.content {
  margin-bottom: 80px;
}

.navbar .pagination{
  margin-bottom: 0px;  
}

.navbar .pagination .form-select{
   border-radius: 0; 
  }

select.page-item {
  text-align: right;
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  height: 80px;
}

.note-warning {
  border-color: #f0ad4e;
  background: #fcf8e3;
}

.note {
  margin: 0 0 20px 0;
  padding: 15px 30px 15px 15px;
  border-left: 3px solid #e5e5e5;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}
.note h1,
.note h2,
.note h3,
.note h4 {
  margin-top: 0;
}
.note p:last-child {
  margin-bottom: 0;
}
p {
  margin: 0 0 10px;
}
</style>
